// Copyright (c) 2017 Deere & Company

export const isValidRange = range => {

    const max = typeof range.max === 'number' ? range.max : Number.MAX_SAFE_INTEGER;
    const min = typeof range.min === 'number' ? range.min : Number.MIN_SAFE_INTEGER;

    return max >= min;

};



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/services/is-valid-range.js